import '../sass/horse-profile.scss';

(() => {
    const $templateParts = document.querySelectorAll('.horse-profile');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $searchDropdown = $templatePart.querySelector('.horse-profile-search-dropdown__dropdown');
        const $links = $templatePart.querySelectorAll('.horse-profile-nav__link');
        const $select = $templatePart.querySelector('.horse-profile-statistics__select');
        const $statisticsTables = $templatePart.querySelectorAll('.horse-profile-statistics__table');
        const $statisticsListItems = $templatePart.querySelectorAll('.horse-profile-statistics__list-item');
        const $videoModalBtns = $templatePart.querySelectorAll('.horse-profile-video-modal-btn');
        const $videoModal = $templatePart.querySelector('.horse-profile-video-modal');
        const $videoPlayer = $templatePart.querySelector('.horse-profile-video-modal__video-player');


        const initSearchDropdown = () => {
            if (!$searchDropdown) return;

            new Details($searchDropdown);
        };

        const initLinks = () => {
            if (!$links) return;

            $links.forEach($link => {
                $link.addEventListener('click', e => {
                    e.preventDefault();
                    
                    const { panel } = $link.dataset;

                    const $panels = document.querySelectorAll(`.horse-profile-panel`);

                    $links.forEach($link => {
                        if ($link.dataset.panel === panel) {
                            $link.classList.add('btn--solid', 'btn--disabled');
                            $link.classList.remove('btn--outline');
                        } else {
                            $link.classList.remove('btn--solid', 'btn--disabled');
                            $link.classList.add('btn--outline');
                        }
                    });

                    $panels.forEach($panel => {
                        if ($panel.classList.contains(`horse-profile-panel--${panel}`)) {
                            $panel.classList.add('horse-profile-panel--show');
                        } else {
                            $panel.classList.remove('horse-profile-panel--show');
                        }
                    });

                    history.replaceState(null, null, $link.href);
                });
            });
        };

        const initStatisticsSelect = () => {
            if (!$select) return;

            $select.addEventListener('change', e => {
                e.preventDefault();

                const { value } = e.target;

                $statisticsTables.forEach($table => {
                    if ($table.classList.contains(`horse-profile-statistics__table--${value}`)) {
                        $table.classList.remove('horse-profile-statistics__table--hide');
                    } else {
                        $table.classList.add('horse-profile-statistics__table--hide');
                    }
                });

                $statisticsListItems.forEach($item => {
                    if ($item.classList.contains(`horse-profile-statistics__list-item--${value}`)) {
                        $item.classList.remove('horse-profile-statistics__list-item--hide');
                    } else {
                        $item.classList.add('horse-profile-statistics__list-item--hide');
                    }
                })
            });
        };
        
        const initModals = () => {
            if (!$videoModal) return;

            if ($videoModalBtns) {
                $videoModalBtns.forEach($btn => {
                    const { vimeoVideoId } = $btn.dataset;

                    $btn.addEventListener('click', () => {
                        let videoPlayer;

                        if ($videoPlayer) {
                            $videoPlayer.innerHTML = `<iframe src="https://player.vimeo.com/video/${vimeoVideoId}?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media&controls=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
                            videoPlayer = new Plyr($videoPlayer);
                            videoPlayer.play();
                        }

                        $videoModal.addEventListener('modalafterclose', () => {
                            videoPlayer?.stop();
                        });

                        openModal($videoModal);
                    });
                });
            }
        };

        initSearchDropdown();
        initLinks();
        initStatisticsSelect();
        initModals();
    });
})();
